import React,{useState,useEffect} from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import "./FooterStyles/FooterSection.scss";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import { toast, ToastContainer } from "react-toastify";

const FooterSection = () => {
    const serviceOptions = [
        { value: "automotive engineering", label: "Automotive Engineering" },
        { value: "software engineering", label: "Software Engineering" },
        { value: "industrial engineering", label: "Industrial Engineering" },
      ];
    
      const [formData, setFormData] = useState({
        name: "",
        email: "",
        service: null,
        country: null,
        state: null,
        message: "",
      });

      const [selectedService, setSelectedService] = useState(null);
      const [isSubmitting, setIsSubmitting] = useState(false);

      const [errors, setErrors] = useState({});

      
     const [stateOptions, setStateOptions] = useState([]);
      useEffect(() => {
        if (formData.country) {
          const states = State.getStatesOfCountry(formData.country.value).map(
            (s) => ({ value: s.isoCode, label: s.name })
          );
          setStateOptions(states);
          setFormData((prev) => ({ ...prev, state: null }));
        }
      }, [formData.country]);
    
      const handleInputChange = (e) => {
        setFormData((prev) => ({ ...prev, [e.target.id]: e.target.value }));
      };
    
      const handleSelectChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
      };
    
      const handleSubmit = async () => {
        const newErrors = {};
        if (!formData.service) newErrors.service = "Domain is required.";
        if (!formData.country) newErrors.country = "Country is required.";
      
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
          toast.error("Please fill in all required fields.");
          return;
        }
      
        setErrors({});
        setIsSubmitting(true);
      
        const dataToSend = {
          name: formData.name,
          email: formData.email,
          service: formData.service?.label,
          country: formData.country?.label,
          state: formData.state?.label,
          message: formData.message,
        };
      
        try {
          const response = await fetch("/sendmail.php", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataToSend),
          });
      
          if (response.ok) {
            toast.success("Submitted successfully!");
            setFormData({
              name: "",
              email: "",
              service: null,
              country: null,
              state: null,
              message: "",
            });
          } else {
            toast.error("Submission failed!");
          }
        } catch (error) {
          console.error("Error submitting the form:", error);
          toast.error("Submission failed!");
        } finally {
          setIsSubmitting(false);
        }
      };
      
      

  return (
    <div className="footer-section">
      <div className="fullscreen section light-section pt-5">
        <div className="footer-main-section">
          <div className="row">
            {/* Left Column */}
            <div className="col-12 col-md-7">
              <div className="row enquirey-section">
                <p className="enquire-text-1">Want to Enquire</p>
                <p className="enquire-text-1">About Our Services?</p>
              </div>

              <div className="row enquirey-content">
                <p className="enquire-content-1">
                  We're here to help! Whether you have questions about our
                  solutions or need expert guidance, feel free to reach out
                </p>
                <div className="divider">
                  <hr className="custom-line" />
                </div>
              </div>

              <div className="contact-location-container">
  <div className="contact-location">
    <h5>Ettiksoft India</h5>
    <p><FontAwesomeIcon icon={faEnvelope} className="icon" /> sales@ettiksoft.com</p>
    <p><FontAwesomeIcon icon={faPhone} className="icon" />  +0422–2345678 </p>
  </div>
  <div className="contact-location">
    <h5>Ettiksoft Europe</h5>
    <p><FontAwesomeIcon icon={faEnvelope} className="icon" /> sales.europe@ettiksoft.ch </p>
    <p><FontAwesomeIcon icon={faPhone} className="icon" />  +41(0)415301864</p>
  </div>
  <div className="contact-location">
    <h5>Ettiksoft Vietnam</h5>
    <p><FontAwesomeIcon icon={faEnvelope} className="icon" /> sales@ettiksoft.com</p>
    <p><FontAwesomeIcon icon={faPhone} className="icon" /> +0422–2345678</p>
  </div>
</div>

            </div>

            {/* Right Column - Enquiry Form */}
            <div className="col-12 col-md-5">
              <div className="row form-section">
                <div className="label">
                  <label>Name</label>
                </div>
                <div className="input">
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    style={{ fontSize: "12px"}}
                  
                  />
                </div>

                <div className="label">
                  <label>Email</label>
                </div>
                <div className="input">
                  <input
                    type="text"
                    id="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    style={{ fontSize: "12px"}}
                   
                  
                  />
                </div>

                <div className="label">
                  <label>Domain <span style={{ color: "red" }}> *</span> </label>
                </div>
                <div className="input">
                <Select
  options={serviceOptions}
  value={formData.service}
  onChange={(selected) => handleSelectChange("service", selected)}
  styles={{
    control: (provided) => ({
      ...provided,
      border: errors.service ? "1px solid red" : "none",
      fontSize: "12px",
      height: "35px",
      minHeight: "35px",
      boxShadow: "none",
      width: window.innerWidth <= 768 ? "95%" : "97%" 
    
    }),
  }}
/>



                </div>

                <div className="row">
             
                    <div className="label">
                      <label>Country <span style={{ color: "red" }}> *</span> </label>
                    </div>
                    <div className="input">
                    
                     <Select
                         options={Country.getAllCountries().map((c) => ({
                          value: c.isoCode,
                          label: c.name,
                        }))} 
                          value={formData.country}
                          onChange={(selected) => handleSelectChange("country", selected)}
                          styles={{
                            control: (provided) => ({
                              ...provided,
                              border: errors.country ? "1px solid red" : "none",
                              fontSize: "12px",
                              height: "35px",
                              minHeight: "35px",
                              boxShadow: "none",
                              width: window.innerWidth <= 768 ? "103%" : "102%" 
                            
                            }),
                          }}
                        />

                    </div>
                 

                
                </div>

                <div className="row">
                  <div className="label">
                    <label>Description</label>
                  </div>
                  <div className="input">
                  <textarea
                    id="message"
                   
                    style={{ fontSize: "12px"}}
                 
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                  </div>
                  
                </div>
                <div className="row button">
                <button className="handle-submit" onClick={handleSubmit} disabled={isSubmitting}>
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection;